module.exports = __webpack_public_path__ + "img/search.18e7977d.svg";